<template>
  <div class="dialog-container wt-dialog-container">
    <div v-loading="isCommunityDetailLoading">
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
      <wt-detail-form-section ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm" :readonly="true" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Community-view',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      formCode: 'MODULES_COMMUNITY',
      isSubmitLoading: false,
      formUpdateUrl: '/modules/community/communityUpdate',
      formAddUrl: '/modules/community/communityAdd',
      detailFormButtons: {
        title: '详情',
        elements: [{ name: '创建', key: 'ADD', action: 'ADD', hidden: this.componentType !== 'add' },
          { name: '保存', key: 'EDIT', action: 'EDIT', hidden: this.componentType !== 'edit' },
          { name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      detailForm: {
        title: '基本信息',
        elements: [
          { name: '文件名称', key: 'name', type: 'text', required: true, disabled: true },
          { name: '创建人id', key: 'createUserId', type: 'text', required: true, disabled: true },
          { name: '区域', key: 'areaId', type: 'text', required: true, disabled: true }]
      }
    }
  },
  created() {
  },
  methods: {
    /*  ------------------------- 按钮  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
      }
    },
    /*  ------------------------- 网络请求  -------------------------  */
    onWtDialogClose() {
      this.$emit('on-dialog-action', 'close')
    }
  },
  computed: {
    ...mapState({
      isCommunityDetailLoading: state => state.community.isCommunityDetailLoading,
      detailFormData: state => state.community.communityDetailData
    })
  }
}
</script>

<style scoped>

</style>
